<template>
  <div class="step-content__row">
    <div>
      <span class="step-content__text"
        >Add 1/2 installation price to estimate price</span
      >
    </div>
    <div>
      <CheckboxField v-model="isHalfInstallation" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { CheckboxField } from "@/shared";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useInstallationStore } from "@/stores/new/installation.store";

const estimateStore = useNewEstimateStore();
const newInstallationStore = useInstallationStore();

const estimate = computed(() => estimateStore.estimate);
const isHalfInstallation = computed({
  get: () => estimate.value.isHalfInstallation,
  set: (value) => {
    estimate.value.isHalfInstallation = value;
  },
});
</script>

<style lang="scss" scoped>
.step-content {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: flex-start;

  margin-top: 32px;
}

.step-content__row {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 30%;
  align-items: center;
}

.step-content__text {
  color: #052141;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
